module.exports = "<div class=\"wrapper\">\n\n  <app-header></app-header>\n  <app-menu></app-menu>\n\n  <div class=\"content-wrapper\">\n    <router-outlet></router-outlet>\n  </div>\n\n  <footer class=\"main-footer\">\n    <strong>Copyright &copy; {{ currentYear }} <a href=\"//weenect.com\">Weenect</a>.</strong> All rights reserved.\n    <div class=\"pull-right\">\n      <b>Version</b> {{ appVersion }}\n    </div>\n  </footer>\n\n</div>\n<simple-notifications [options]=\"notificationOptions\"></simple-notifications>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main